module.exports = __webpack_public_path__ + "img/product_87.48e87d5.webp";